import moment from 'moment';

import { translate } from './translation-utils';
import { DMARC_NONE, DMARC_QUARANTINE, DMARC_REJECT } from '../common/constants/dmarc-policy-values';
import { AUTH_STATUS_NO_RECORD, AUTH_STATUS_VALID } from '../common/constants/definitions';

export const calculateRate = ( totalAmount, percentValue ) => {
    if( totalAmount > 0 && percentValue > 0 ){
        return ( ( percentValue / totalAmount ) * 100 );
    }

    return 0;
};

export const formatBool = ( value ) => value ? 'Y' : 'N';

export const formatCommaSeparatedList = ( values = [] ) => {
    if( Array.isArray( values ) && values.length > 0 ){
        return values.join( ', ' );
    }
    return 'n/a';
};

export const formatDate = ( value, interval = 'YYYY/MM/DD' ) => {
    if( !value ){
        return 'n/a';
    }

    const momentDate = moment( value );

    const INTERVAL_MAP = ( momentDate ) => {
        return {
            day: momentDate.format( 'YYYY/MM/DD' ),
            month: momentDate.format( 'MMM YYYY' ),
            quarter: momentDate.format( '[Q]Q YYYY' ),
            week: 'Week of ' + momentDate.format( 'YYYY/MM/DD' ),
        };
    };

    return INTERVAL_MAP( momentDate )[interval] || momentDate.format( interval );
};

export const formatForNull = ( item ) => {
    return item === null || item === undefined || item === '' ? 'na' : item;
};

export const formatNumber = ( value ) => value.toLocaleString();

export const formatRate = ( value ) => {
    let formattedValue = value;

    if( typeof value === 'string' ){
        formattedValue = Number( value );
    }

    if( typeof value === 'number' ){
        formattedValue = value;
    }

    return formattedValue ?
        `${formattedValue.toLocaleString( undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 } )}%` :
        '0.00%';
};

export const formatMultiSelectData = ( selectData, valId = 'id', labelId = 'name' ) => {
    const formattedSelectData = [];
    for( let data of selectData ){
        let label = data;
        let value = data;

        if( typeof data === 'object' ){
            label = data[labelId];
            value = data[valId];
        }
        formattedSelectData.push( { label: label, value: value } );
    }
    return formattedSelectData;
};

export const formatSubDomainDmarcPolicy = ( policy ) => {
    let formattedValue;
    switch( policy ){
        case DMARC_NONE:
        case DMARC_QUARANTINE:
        case DMARC_REJECT:
            formattedValue = `sp=${policy}`;
            break;
        default:
            formattedValue = 'No subdomain policy';
            break;
    }

    return formattedValue;
};

export const validateDomain = ( domain ) => {
    const domainPattern = /(?:\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
    // eslint-disable-next-line
    const specialCharacters = /[~`!#$%@\^&*+=\[\]\\';/{}|\\":<>\?()]/g;
    const whiteSpace = /\s/g;

    const correctlyFormattedDomain = domainPattern.test( domain );
    const noSpecialCharacters = !specialCharacters.test( domain );
    const noWhiteSpace = !whiteSpace.test( domain );

    return correctlyFormattedDomain && noSpecialCharacters && noWhiteSpace;
};

export const buildDomainManagementBulkSuccessMessage = ( successfulDomainsTotal, domainActionType, domainType ) => {
    const DOMAIN_ACTION_TYPE_MAP = {
        add: 'added.',
        changeType: `changed as ${( translate( domainType ) || '' ).toLowerCase()}.`,
        claim: 'claimed.',
        remove: 'removed.'
    };
    const message = `${successfulDomainsTotal} ${successfulDomainsTotal === 1 ? 'domain has' : 'domains have'} been ${DOMAIN_ACTION_TYPE_MAP[domainActionType]}`;

    return message;
};

export const domainsErrorMessageBuilder = ( domainActionType, errorType ) => {
    const domainActionToTextMap = {
        add: 'add',
        changeType: 'change',
        claim: 'claim',
        remove: 'remove',
        undefined: 'update'
    };

    const domainErrorMessages = {
        alreadyClaimedDomains: ( domainActionType ) => `We couldn't ${domainActionType} the following domains because they have already been claimed.`,
        failedDomains: ( domainActionType ) => `We couldn't ${domainActionType} the following domains because they failed.`,
        invalidDomains: ( domainActionType ) => `We couldn't ${domainActionType} the following domains because they are invalid domains.`,
        notFoundDomains: ( domainActionType ) => `We couldn't ${domainActionType} the following domains because they were not found.`,
        unclaimedDomains: ( domainActionType ) => `We couldn't ${domainActionType} the following domains because they have not been claimed.`,
        undefined: ( domainActionType ) => `We couldn't ${domainActionType} the following domains.`,
    };

    return domainErrorMessages[errorType]( domainActionToTextMap[domainActionType] );
};

export const formatAuthValue = ( status, record ) => {
    // Set default to No Record
    // in case status is ever undefined
    let currentValue = translate( AUTH_STATUS_NO_RECORD );
    if( status === AUTH_STATUS_VALID ){
        currentValue = record;
    }
    else if( translate( status ) ){
        currentValue = translate( status );
    }

    return currentValue;
};
